export default "__VITE_ASSET__TwD_BwEX__"